import { createContext, useContext } from 'react';

interface Context {
    isOpen: boolean;
    onContinue: () => void;
    reOpen: () => void;
}

export const ConsentContext = createContext<Context>({} as Context);

export const useConsentContext = () => useContext(ConsentContext);
